import type { v2 } from '@deque/billing-service-client';
import { apiRequest } from '../../../api-client';

export default {
  /** Get the list of billing products. */
  list(): Promise<v2.Product[]> {
    return apiRequest({ endpoint: '/api/billing/v2/products' });
  }
};
